
// src/views/DashboardOverview.jsx
import React from 'react';

function DashboardOverview() {
  return (
    <div>
      <h2>Welcome to the EpicNyte Admin Dashboard</h2>
      <p>Use the sidebar to manage your data: venues, locations, music, and footfall analytics.</p>
    </div>
  );
}

export default DashboardOverview;
